import { render } from "./HistorySection.vue?vue&type=template&id=701fe6ff"
import script from "./HistorySection.vue?vue&type=script&lang=js"
export * from "./HistorySection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__